<template>
    <div class="login d-flex w-100">
        <div class="login-form my-auto mx-auto">
            <div class="d-flex mb-3">
                <div class="d-flex align-items-center mx-auto">
                    <b-img src="//cdn.studiesweekly.com/img/sbp_logo.svg" width="50" height="auto"/>
                </div>
            </div>
            <div id="g_id_onload"
                 :data-client_id="client_id"
                 data-ux_mode="redirect"
                 :data-login_uri="google_redirect_url">
            </div>
            <div class="g_id_signin mb-3" style="text-align: -webkit-center;" data-type="standard"></div>

            <login-form @login="login"/>
        </div>
    </div>

</template>

<style scoped lang="scss">
@import "@/assets/css/_colors.scss";

.login-form {
    min-width: calc(100% - 2rem);
}

@media (min-width: 768px) {
    .login-form {
        min-width: 400px;
    }
}

.login {
    height: 100vh;
}
</style>

<script>
import LoginForm from '@/components/LoginForm'

export default {
    name: 'Login',
    data: () => ({
        client_id: null,
        google_redirect_url: window.location.origin + '/api/google_login',
    }),
    components: {
        LoginForm
    },
    async mounted() {
        this.client_id = (await this.axios.get('/api/google_client_id')).data;
        let redirectScript = document.createElement('script')
        redirectScript.setAttribute('src', 'https://accounts.google.com/gsi/client')
        document.head.appendChild(redirectScript)
    },
    methods: {
        login() {
            if (
                this.$route.query &&
                this.$route.query.redirect
            ) {
                this.$router.push({
                    path: this.$route.query.redirect
                })
            } else {
                this.$router.push({
                    path: '/'
                })
            }
        }
    }
}
</script>
